import React from 'react';
import {Grid} from "semantic-ui-react";
import Field from "../../components/forms/field";
import FormattedDate from "../../components/formatters/formattedDate";
import Currency from "../../components/formatters/currency";
import Decimal from "../../components/formatters/decimal";

class ContractDetails extends React.Component {
    render() {
        return (
            <Grid padded stackable columns='equal'>
                <Grid.Row>
                    <Grid.Column>
                        <Field label={"Contract Start Date"} value={<FormattedDate value={this.props.contractData.contractStartDate}/>} />
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"Contract End Date"} value={<FormattedDate value={this.props.contractData.contractEndDate}/>}/>
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"Traded Cost"} value={<Currency value={this.props.contractData.tradedCost} />} />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                        <Field label={"Supplier"} value={this.props.contractData.supplierName}/>
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"Utility"} value={this.props.contractData.utilityName}/>
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"Exposed Cost"} value={<Currency value={this.props.contractData.exposedCost}/>}/>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                        <Field label={"Mark Total Cost"} value={<Currency value={this.props.contractData.markTotalCost} /> } />
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"Mark Cost per Unit (MWh)"} value={<Currency value={this.props.contractData.markCostPerUnit} /> } />
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"Percentage Traded"} value={<Decimal value={this.props.contractData.percentTraded} /> } />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                        <Field label={"Market Total Cost"} value={<Currency value={this.props.contractData.marketTotalCost}/>}/>
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"Market Cost per Unit (MWh)"} value={<Currency value={this.props.contractData.marketCostPerUnit}/>}/>
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"Percentage Exposed"} value={<Decimal value={this.props.contractData.percentExposed} />} />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                        <Field label={"Total Volume"} value={<Decimal value={this.props.contractData.totalVolume}/>} />
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"Traded Volume"} value={<Decimal value={this.props.contractData.tradedVolume}/>}/>
                    </Grid.Column>
                    <Grid.Column>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }
}

export default ContractDetails;